// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { env } from './.env';
import { EnvironmentModel } from './environment-model';
import { ProductTypeEnum } from '@core/enums/product-type.enum';

export const environment: EnvironmentModel = {
  production: true,
  apiUrl: 'http://localhost:5005',
  signalRUrl: 'http://localhost:5002',
  tempUrl: 'http://localhost/?',
  version: '3.12.0',
  defaultLanguage: env.defaultLanguage,
  availableLangs: env.availableLangs,
  defaultsConfig: env.defaultsConfig,
  productType: ProductTypeEnum.Sentinel
};
